import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { EmbeddedPasswordrequestPageRoutingModule } from './embedded-passwordrequest-routing.module';

import { EmbeddedPasswordrequestPage } from './embedded-passwordrequest.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    EmbeddedPasswordrequestPageRoutingModule
  ],
  declarations: [EmbeddedPasswordrequestPage]
})
export class EmbeddedPasswordrequestPageModule {}
